import * as React from 'react';
import type {
  Trip,
  CreateTripPayload as Payload
} from 'contracts/tracking-v2/trips';
import { api, handleApiError } from 'services/api';

export const useCreateTrip = () => {
  const createTrip = React.useCallback(async (payload: Payload) => {
    try {
      const url = '/tracking-v2/trips';
      const { data } = await api.post<Trip>(url, payload);
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    createTrip,
  };
};